import React, { useRef, useState } from "react";
import GridSlotControls from "../GridSlotControls";
import Image from "components/Image";

export const gridItemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export default function GridSlotItem({
  isDisabled,
  item,
  onSubmit = () => {},
  onTimeout = () => {},
}) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const inputRef = useRef(null);

  function handleFocusInput() {
    if (inputRef.current) {
      inputRef.current?.focus();
    }
  }

  return (
    <>
      {item && (
        <div
          className="h-full text-center cursor-pointer flex justify-center gap-2 flex-col "
          onClick={handleFocusInput}
        >
          <GridSlotControls
            ref={inputRef}
            data={item}
            disabled={isDisabled || !imageLoaded}
            onSubmit={onSubmit}
            onTimeout={onTimeout}
          />
          <div className="p-4 h-full">
            <Image
              onLoad={(e) => {
                setImageLoaded(true);
              }}
              onError={(e) => {
                setImageLoaded(false);
              }}
              key={`image-${item.imageId}`}
              src={item.imagePath}
            />
          </div>
        </div>
      )}

      {!item && (
        <div className="flex justify-center items-center h-full">
          <div className="text-2xl font-bold text-gray-400">
            Məhsullar bitdi
          </div>
        </div>
      )}
    </>
  );
}
